import { getObjectYCommandParams } from '@components/TimeLineGrid/helpers/getObjectYCommandParams'

import { useExecuteCommandMutation } from '@redux/api'

import { ListQueryResponse, SortType } from '@hooks'
import { getCommandRequestData } from '@helpers'
import { TIME_LINE_PAGINATION_SIZE } from '@constants'
import { ExecuteCommandPayload, ObjectDataRecord, TimeLineDTOType } from '@types'

import { getAllPagesData } from '../helpers'

export const useGetDataFromObjectYCommand = () => {
  const [executeCommand, { data, isUninitialized }] = useExecuteCommandMutation()

  const commandData = data as ListQueryResponse<ObjectDataRecord>

  const getData = ({
    config,
    escapedKeyFieldValues,
    saRSQLFilter,
    sort,
  }: {
    config: TimeLineDTOType
    escapedKeyFieldValues?: unknown[]
    saRSQLFilter: string | null
    sort: SortType[]
  }) => {
    const command = config.objectY.getDataCommand

    const commandParams: ExecuteCommandPayload = {
      transformResponseWithPagination: true,
      objectCode: config.objectY.objectCode,
      commandCode: command?.name as string,
      size: TIME_LINE_PAGINATION_SIZE,
      method: command?.httpMethod,
      params: getObjectYCommandParams({
        config,
        commandParameters: command?.parameters,
        saRSQLFilter,
        objectYKeyFieldsValues: escapedKeyFieldValues,
        sort,
      }),
      body:
        command?.body && command?.httpMethod !== 'GET'
          ? getCommandRequestData(command.body, {})
          : undefined,
    }

    return executeCommand(commandParams)
      .unwrap()
      .then(result =>
        getAllPagesData({
          firstPageData: result as ListQueryResponse<ObjectDataRecord>,
          executeCommand,
          commandParams,
        })
      )
  }

  return {
    getDataFromObjectYCommand: getData,
    totalCountElements: commandData?.totalCountElements,
    isUninitialized,
  }
}
